import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { API_URL } from '../config';
import TypeBadge from '../components/TypeBadge';
import './CompetitiveData.css';

// Local sprites for Champions/ZA-exclusive Mega Stones not in PokeAPI
/* eslint-disable import/no-webpack-loader-syntax */
const LOCAL_STONE_SPRITES = {
  'Absolite Z':    require('../assets/mega stones/60px-Bag_Absolite_Z_ZA_Sprite.png'),
  'Barbaracite':   require('../assets/mega stones/60px-Bag_Barbaracite_ZA_Sprite.png'),
  'Baxcalibrite':  require('../assets/mega stones/60px-Bag_Baxcalibrite_ZA_Sprite.png'),
  'Chandelurite':  require('../assets/mega stones/60px-Bag_Chandelurite_ZA_Sprite.png'),
  'Chesnaughtite': require('../assets/mega stones/60px-Bag_Chesnaughtite_ZA_Sprite.png'),
  'Chimechite':    require('../assets/mega stones/60px-Bag_Chimechite_ZA_Sprite.png'),
  'Clefablite':    require('../assets/mega stones/60px-Bag_Clefablite_ZA_Sprite.png'),
  'Crabominite':   require('../assets/mega stones/60px-Bag_Crabominite_ZA_Sprite.png'),
  'Darkranite':    require('../assets/mega stones/60px-Bag_Darkranite_ZA_Sprite.png'),
  'Delphoxite':    require('../assets/mega stones/60px-Bag_Delphoxite_ZA_Sprite.png'),
  'Dragalgite':    require('../assets/mega stones/60px-Bag_Dragalgite_ZA_Sprite.png'),
  'Dragoninite':   require('../assets/mega stones/60px-Bag_Dragoninite_ZA_Sprite.png'),
  'Drampanite':    require('../assets/mega stones/60px-Bag_Drampanite_ZA_Sprite.png'),
  'Eelektrossite': require('../assets/mega stones/60px-Bag_Eelektrossite_ZA_Sprite.png'),
  'Emboarite':     require('../assets/mega stones/60px-Bag_Emboarite_ZA_Sprite.png'),
  'Excadrite':     require('../assets/mega stones/60px-Bag_Excadrite_ZA_Sprite.png'),
  'Falinksite':    require('../assets/mega stones/60px-Bag_Falinksite_ZA_Sprite.png'),
  'Feraligite':    require('../assets/mega stones/60px-Bag_Feraligite_ZA_Sprite.png'),
  'Floettite':     require('../assets/mega stones/60px-Bag_Floettite_ZA_Sprite.png'),
  'Froslassite':   require('../assets/mega stones/60px-Bag_Froslassite_ZA_Sprite.png'),
  'Garchompite Z': require('../assets/mega stones/60px-Bag_Garchompite_Z_ZA_Sprite.png'),
  'Glimmoranite':  require('../assets/mega stones/60px-Bag_Glimmoranite_ZA_Sprite.png'),
  'Golisopite':    require('../assets/mega stones/60px-Bag_Golisopite_ZA_Sprite.png'),
  'Golurkite':     require('../assets/mega stones/60px-Bag_Golurkite_ZA_Sprite.png'),
  'Greninjite':    require('../assets/mega stones/60px-Bag_Greninjite_ZA_Sprite.png'),
  'Hawluchanite':  require('../assets/mega stones/60px-Bag_Hawluchanite_ZA_Sprite.png'),
  'Heatranite':    require('../assets/mega stones/60px-Bag_Heatranite_ZA_Sprite.png'),
  'Lucarionite Z': require('../assets/mega stones/60px-Bag_Lucarionite_Z_ZA_Sprite.png'),
  'Magearnite':    require('../assets/mega stones/60px-Bag_Magearnite_ZA_Sprite.png'),
  'Malamarite':    require('../assets/mega stones/60px-Bag_Malamarite_ZA_Sprite.png'),
  'Meganiumite':   require('../assets/mega stones/60px-Bag_Meganiumite_ZA_Sprite.png'),
  'Meowsticite':   require('../assets/mega stones/60px-Bag_Meowsticite_ZA_Sprite.png'),
  'Pyroarite':     require('../assets/mega stones/60px-Bag_Pyroarite_ZA_Sprite.png'),
  'Raichunite X':  require('../assets/mega stones/60px-Bag_Raichunite_X_ZA_Sprite.png'),
  'Raichunite Y':  require('../assets/mega stones/60px-Bag_Raichunite_Y_ZA_Sprite.png'),
  'Scolipite':     require('../assets/mega stones/60px-Bag_Scolipite_ZA_Sprite.png'),
  'Scovillainite': require('../assets/mega stones/60px-Bag_Scovillainite_ZA_Sprite.png'),
  'Scraftinite':   require('../assets/mega stones/60px-Bag_Scraftinite_ZA_Sprite.png'),
  'Skarmorite':    require('../assets/mega stones/60px-Bag_Skarmorite_ZA_Sprite.png'),
  'Staraptite':    require('../assets/mega stones/60px-Bag_Staraptite_ZA_Sprite.png'),
  'Starminite':    require('../assets/mega stones/60px-Bag_Starminite_ZA_Sprite.png'),
  'Tatsugirinite': require('../assets/mega stones/60px-Bag_Tatsugirinite_ZA_Sprite.png'),
  'Victreebelite': require('../assets/mega stones/60px-Bag_Victreebelite_ZA_Sprite.png'),
  'Zygardite':     require('../assets/mega stones/60px-Bag_Zygardite_ZA_Sprite.png'),
};
/* eslint-enable import/no-webpack-loader-syntax */

function getMegaStoneSprite(stoneName) {
  if (LOCAL_STONE_SPRITES[stoneName]) return LOCAL_STONE_SPRITES[stoneName];
  return `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/items/${stoneName.toLowerCase().replace(/\s+/g, '-')}.png`;
}

const CompetitiveData = () => {
  const [pokemon, setPokemon] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sortBy] = useState('usagePercent');
  const [sortOrder] = useState('desc');
  const [searchTerm] = useState('');
  const [typeFilter] = useState('all');
  const location = useLocation();
  const navigate = useNavigate();
  const gridRef = useRef(null);

  // Save scroll position before navigating away
  const handlePokemonClick = (pokedexId) => {
    const currentScroll = gridRef.current?.scrollTop || window.scrollY;
    navigate(`/pokemon/${pokedexId}`, { 
      state: { 
        from: 'competitive',
        scrollPosition: currentScroll 
      } 
    });
  };

  // Restore scroll position when component mounts or when returning from a Pokemon detail page
  useEffect(() => {
    if (location.state?.scrollPosition && !loading) {
      const scrollPosition = location.state.scrollPosition;
      if (gridRef.current) {
        gridRef.current.scrollTop = scrollPosition;
      } else {
        window.scrollTo(0, scrollPosition);
      }
    }
  }, [location.state?.scrollPosition, loading]);

  const fetchPokemon = useCallback(async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_URL}/competitive/pokemon?limit=100&sort=${sortBy}&order=${sortOrder}&search=${searchTerm}&type=${typeFilter}`);
      if (!response.ok) {
        throw new Error('Failed to fetch Pokemon data');
      }
      const data = await response.json();
      setPokemon(data);
      setError(null);
    } catch (err) {
      setError(err.message);
      setPokemon([]);
    } finally {
      setLoading(false);
    }
  }, [sortBy, sortOrder, searchTerm, typeFilter]);

  useEffect(() => {
    fetchPokemon();
  }, [fetchPokemon]);

  const getPokemonSprite = (p) => {
    return p.sprites?.other?.['official-artwork']?.front_default || 
           p.sprites?.front_default || 
           `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/${p.pokedexId}.png`;
  };

  // Filter out "Other" from abilities, items, and moves
  const filterOutOther = (items) => {
    return items?.filter(item => item.name.toLowerCase() !== 'other') || [];
  };

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (error) {
    return <div className="error">Error: {error}</div>;
  }

  return (
    <div className="competitive-data">
      <div className="competitive-data__header">
        <h1>Common Competitive Pokemon</h1>
        <div className="competitive-data__format-badge">
          <span className="format-badge">Double Battles</span>
          <span className="format-reg">Regulation M-A · Pokémon Champions</span>
        </div>
        <p className="competitive-data__format-desc">
          VGC format: register 6 Pokémon, both players see each other's full teams, then each selects 4 to battle.
        </p>
      </div>

      <div className="competitive-data__grid" ref={gridRef}>
        {pokemon.map((p) => (
          <div key={p.pokedexId} className="competitive-data__card">
            <div className="competitive-data__card-header">
              <div className="competitive-data__card-info">
                <div 
                  onClick={() => handlePokemonClick(p.pokedexId)}
                  className="competitive-data__pokemon-link"
                  style={{ cursor: 'pointer' }}
                >
                  <h3 className="competitive-data__name">{p.name}</h3>
                </div>
                <div className="type-badges">
                  {p.types?.map((type) => (
                    <TypeBadge key={`${p.pokedexId}-${type}`} type={type} />
                  ))}
                </div>
              </div>
              <div className="competitive-data__sprite-container">
                <img
                  src={getPokemonSprite(p)}
                  alt={p.name}
                  className="competitive-data__sprite"
                  loading="lazy"
                  onError={(e) => {
                    e.target.onerror = null;
                    // First try the regular sprite
                    e.target.src = `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/${p.pokedexId}.png`;
                    // If that fails too, use a placeholder
                    e.target.onerror = () => {
                      e.target.src = '/placeholder-pokemon.png';
                      e.target.onerror = null;
                    };
                  }}
                />
              </div>
            </div>

            <div className="competitive-data__sections">
              <div className="competitive-data__section">
                <h4>Abilities</h4>
                <ul className="competitive-data__list">
                  {filterOutOther(p.abilities)?.map((ability) => (
                    <li key={ability.name} className={ability.isMega ? 'competitive-data__ability--mega' : ''}>
                      <Link
                        to={`/abilities/${ability.name.replace(/\s+/g, '-')}`}
                        className="competitive-data__link"
                        state={{ from: 'competitive', scrollPosition: window.scrollY }}
                      >
                        {ability.name}
                      </Link>
                      {ability.isMega && ability.megaStone && (
                        <img
                          className="competitive-data__mega-stone-icon"
                          src={getMegaStoneSprite(ability.megaStone)}
                          alt={ability.megaStone}
                          title={`${ability.megaStone} — Mega Evolution ability`}
                        />
                      )}
                      <span></span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="competitive-data__section">
                <h4>Common Items</h4>
                <ul className="competitive-data__list">
                  {filterOutOther(p.items)?.map((item) => (
                    <li key={item.name} className={item.isMegaStone ? 'competitive-data__ability--mega' : ''}>
                      <Link
                        to={`/items/${item.name.replace(/\s+/g, '-')}`}
                        className="competitive-data__link"
                        state={{ from: 'competitive', scrollPosition: window.scrollY }}
                      >
                        {item.name}
                      </Link>
                      {item.isMegaStone && (
                        <img
                          className="competitive-data__mega-stone-icon"
                          src={getMegaStoneSprite(item.name)}
                          alt={item.name}
                          title={item.name}
                          onError={e => { e.target.style.display = 'none'; }}
                        />
                      )}
                      <span></span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="competitive-data__section">
                <h4>Common Moves</h4>
                <ul className="competitive-data__list">
                  {filterOutOther(p.moves)?.map((move) => (
                    <li key={move.name}>
                      <Link 
                        to={`/moves/${move.name.replace(/\s+/g, '-')}`}
                        className="competitive-data__link"
                        state={{ from: 'competitive', scrollPosition: window.scrollY }}
                      >
                        {move.name}
                      </Link>
                      <span></span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CompetitiveData;